import React from 'react'
import { StyledIconButton } from './style'
import { Tooltip } from 'components'
import classnames from 'classnames'

const IconButton = ({ tooltip, className, onClick, disabled, ...props }) => {
  const handleClick = (e) => {
    onClick(e)
    e.target.blur() // Removes the focus to avoid showing up tooltips on focus due to modal windows
  }

  const iconButton = (
    <StyledIconButton
      type="button"
      className={classnames(className, { clickable: !disabled })}
      onClick={handleClick}
      disabled={disabled}
      {...props}
    >
      {props.icon}
      {props.text}
    </StyledIconButton>
  )

  return tooltip && !disabled ? (
    <Tooltip text={tooltip}>{iconButton}</Tooltip>
  ) : iconButton
}

export default IconButton

